
let _locked = false;
interface waitForLockParams<T>{
    interval?: number,
    maxDelay?: number,
    cbk:()=>Promise<T>,
    /**
     * Should callback be executed when timer is expired
     */
    executeAfterTimeout?: boolean,
    /**
     * Should we raise exception when timer is expired
     * if yes: ()=>error
     * if no: falsy value
     */
    raiseErrorOnTimeout?: null|false|(()=>unknown),
    unlockOnTimeout?:boolean,
    fallbackReturnValue?:null|T,
    lockHandlers?: lockHandlersInterface
}

export interface lockHandlersInterface{
    engageLock:()=>{},
    disengageLock:()=>{},
    checkLock:()=>boolean
}

export const waitForLock = async <T> (params:waitForLockParams<T>)=>{

    const {
      interval = 50,
      maxDelay = 3000,
      cbk = ()=>null,
      executeAfterTimeout = false,
      raiseErrorOnTimeout = ()=>new Error('Lock timeouted'),
      unlockOnTimeout = true,
      fallbackReturnValue = null,
    }: waitForLockParams<T> = params;

    //now we bind all the lock handling functions:
    const {
      lockHandlers = {
        engageLock: ()=>{_locked = true;},
        disengageLock: ()=>{_locked = false;},
        checkLock: ()=>_locked
      }} = params;

    let expiration = maxDelay;

    if(!lockHandlers.checkLock()){
      lockHandlers.engageLock();
      const result = await cbk();
      lockHandlers.disengageLock();
      return result;
    }

    return new Promise<T>(resolve=>{
        const i = setInterval(async ()=>{

            if(!lockHandlers.checkLock()){
              clearInterval(i);
              const result = await waitForLock<T>(params);
              resolve(result);
              return result;
            }

            //decrement the counter for time left
            expiration -= interval;

            //if timer is expired, we do alternate actions
            if(expiration < 0){

              clearInterval(i);

              if(unlockOnTimeout){
                lockHandlers.disengageLock();
              }

              if(executeAfterTimeout){
                const result = await cbk();
                resolve(result);
                return result;
              }

              if(raiseErrorOnTimeout){
                throw raiseErrorOnTimeout();
              }

              return fallbackReturnValue;
            }

        },interval);
    });
};
